import * as React from 'react';
import { useState, useEffect, useContext } from 'react';
import { MediaObject } from '@/shared/types';
import { MediaDisplay } from '../ui/mediaDisplay';
import { UsableMediaTypes } from '@/shared/constants';
import { FullScreenContext } from '@/app/contexts';
const Media = (props: {
  value: {
    id: string;
    mediaType: string;
    mediaSrc: string;
    mediaUrl: string;
  };
  showType: boolean;
  width: number;
  height: number;
  isInModal: boolean;
}) => {
  const {
    isFullscreen
  } = useContext(FullScreenContext);
  const mediaItem = (props?.value as any)?.[0] || props?.value;
  return <div className="flex items-center justify-center" data-sentry-component="Media" data-sentry-source-file="media.tsx">
      {!isFullscreen && mediaItem && UsableMediaTypes.includes(mediaItem?.mediaType || '') ? <MediaDisplay mediaItem={mediaItem} isTable={true} /> : <div className='flex flex-row gap-1 items-center justify-center p-[4px]'>
        </div>}
    </div>;
};
Media.displayName = 'Media';
export default Media;